module.exports = __webpack_public_path__ + "static/media/hydropurr-4.71c0cedb.jpg";